/**
 * @flow
 * @relayHash b1defd2fe7063c3d24bc6150515ade76
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CategoriesEditor_viewer$ref = any;
export type CategoriesEditorRefetchQueryVariables = {|
  section: string
|};
export type CategoriesEditorRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: CategoriesEditor_viewer$ref
  |}
|};
export type CategoriesEditorRefetchQuery = {|
  variables: CategoriesEditorRefetchQueryVariables,
  response: CategoriesEditorRefetchQueryResponse,
|};
*/


/*
query CategoriesEditorRefetchQuery(
  $section: ID!
) {
  viewer {
    ...CategoriesEditor_viewer_1hrbBR
    id
  }
}

fragment CategoriesEditor_viewer_1hrbBR on Viewer {
  id
  categories(first: -1, section: $section) {
    edges {
      node {
        id
        name
        hidden
        slug
        section
        seoTitle
        seoKeywords
        seoDescription
      }
    }
  }
  sections {
    edges {
      node {
        id
        name
        hidden
      }
    }
  }
  section(id: $section) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "section",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hidden",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "CategoriesEditorRefetchQuery",
  "id": null,
  "text": "query CategoriesEditorRefetchQuery(\n  $section: ID!\n) {\n  viewer {\n    ...CategoriesEditor_viewer_1hrbBR\n    id\n  }\n}\n\nfragment CategoriesEditor_viewer_1hrbBR on Viewer {\n  id\n  categories(first: -1, section: $section) {\n    edges {\n      node {\n        id\n        name\n        hidden\n        slug\n        section\n        seoTitle\n        seoKeywords\n        seoDescription\n      }\n    }\n  }\n  sections {\n    edges {\n      node {\n        id\n        name\n        hidden\n      }\n    }\n  }\n  section(id: $section) {\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "CategoriesEditorRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CategoriesEditor_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "section",
                "variableName": "section",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CategoriesEditorRefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v1,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "categories",
            "storageKey": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": -1,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "section",
                "variableName": "section",
                "type": "ID!"
              }
            ],
            "concreteType": "CategoryConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Category",
                    "plural": false,
                    "selections": [
                      v1,
                      v2,
                      v3,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "slug",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "section",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "seoTitle",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "seoKeywords",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "seoDescription",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "sections",
            "storageKey": null,
            "args": null,
            "concreteType": "SectionConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SectionEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Section",
                    "plural": false,
                    "selections": [
                      v1,
                      v2,
                      v3
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "section",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "section",
                "type": "ID!"
              }
            ],
            "concreteType": "Section",
            "plural": false,
            "selections": [
              v1
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '904f50f011907e79d9540c2254a47c3e';
module.exports = node;



// WEBPACK FOOTER //
// src/components/categories/__generated__/CategoriesEditorRefetchQuery.graphql.js